/**
 * Render an uptime percentage, as legacy's `Formatter.percentage` does
 * (web/jskit/general/Formatter.js:269) — one function for the global stat and the per-component
 * rows, so the two cannot disagree.
 *
 * Rounds with plain `toFixed`, neither floored nor ceiled, and keeps trailing zeros. Legacy's one
 * exception is kept too: a value rounding up to 100 prints a bare "100%" rather than claiming
 * "100.000%". Nothing recorded renders as nothing, not "0.000%", which would read as a total outage.
 *
 * @param percent uptime already expressed 0-100, not a 0-1 fraction.
 */
export const formatUptimePercentage = (percent: number | null | undefined): string => {
  if (percent === null || percent === undefined || Number.isNaN(percent)) return "";
  const value = percent.toFixed(3);
  return `${value.startsWith("100.") ? "100" : value}%`;
};
